import { render, staticRenderFns } from "./CompanySubmittedContent.vue?vue&type=template&id=0482de4b"
import script from "./CompanySubmittedContent.vue?vue&type=script&lang=js"
export * from "./CompanySubmittedContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports